import React from 'react';
import bemify from 'bemify-js';

import { StaticImage } from '@zapier/common-components';

import Link from 'app/common/components/Link';

import './NextSteps.scss';
import Confetti from '../components/Confetti';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';

const bem = bemify('next-steps');

const NextStepsTutorial = () => (
  <div className={bem()}>
    <div className={bem('__hero')}>
      <StaticImage
        alt="next-steps-emoji"
        className={bem('__image')}
        src="https://cdn.zapier.com/zapier/images/developer-guide/next-steps-emoji.svg"
        title="Smiling face"
      />
      <Confetti />
      <StepTitle>Congrats! You set up your environment.</StepTitle>
    </div>
    <Paragraph>
      Good news! You've just set up your Zapier development environment, created
      an app, run your first automated test, and deployed your app to the Zapier
      platform! Whew! Take a break, then come back and let's keep going.
    </Paragraph>
    <Paragraph>
      Our{' '}
      <Link
        href="https://github.com/zapier/zapier-platform/blob/main/packages/cli/README.md"
        target="_blank"
      >
        developer docs
      </Link>{' '}
      will help you actually build some functionality into your app and
      integrate your API with the Zapier platform.
    </Paragraph>
  </div>
);

export default NextStepsTutorial;
